import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCategoryState: IMidMenuData = {
  data: {
    productMidMenu: [],
    meta: {},
  },
  deleteSuccess: false,
  sortMidMenuData: [],
  loading: false,
  success: false,
}

export interface IMidMenuData {
  data: {
    productMidMenu: any
    meta: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  sortMidMenuData: IMidMenuData[]
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: IMidMenuData = initialCategoryState,
  action: ActionWithPayload<IMidMenuData>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_MID_MENU_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_MID_MENU_MANAGER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_ALL_MID_MENU_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_SPECIFIC_MID_MENU_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_SPECIFIC_MID_MENU_MANAGER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_SPECIFIC_MID_MENU_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_MID_MENU_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_MID_MENU_MANAGER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_MID_MENU_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_MID_MENU_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_MID_MENU_MANAGER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_MID_MENU_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_MID_MENU_MANAGER_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_MID_MENU_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_MID_MENU_MANAGER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_MID_MENU_MANAGER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_MID_MENU_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_MID_MENU_MANAGER_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_MID_MENU_MANAGER_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_MID_MENU_MANAGER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_MID_MENU_MANAGER_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_MID_MENU_MANAGER_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_MID_MENU_MANAGER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_MID_MENU_MANAGER_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_MID_MENU_MANAGER_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_MID_MENU_MANAGER_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_MID_MENU_MANAGER_SUCCESS: {
      return {
        ...state,
        sortMidMenuData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_MID_MENU_MANAGER_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_MID_MENU_MANAGER_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortMidMenuData: [],
      }
    }

    default:
      return state
  }
}
